"use client";

import React from 'react';
import { Box } from 'components/Box';
import { Collapse, CollapseContent } from 'components/Collapse';
import { Text } from 'components/Text';
import { VisuallyHidden } from 'components/VisuallyHidden';
import type { TextFieldErrorTypes } from './types';

export type InlineErrorProps = {
  error?: string | { message: string } | any;
  errorId: string;
  errorVariant?: TextFieldErrorTypes;
  hasError?: boolean;
};

export function InlineError({
  error,
  errorId,
  errorVariant,
  hasError,
}: InlineErrorProps) {
  if (hasError && errorVariant === 'tooltip') {
    return (
      <VisuallyHidden id={errorId}>
        {typeof error === 'string' ? error : error.message}
      </VisuallyHidden>
    );
  }
  return (
    <Collapse isShowing={hasError && errorVariant === 'inline'}>
      <CollapseContent aria-labelledby={undefined} role={undefined}>
        <Box id={errorId} paddingX={1} paddingY={4} role="alert">
          {typeof error === 'string' ? (
            <Text color="error" variant="caption">
              {error}
            </Text>
          ) : (
            error
          )}
        </Box>
      </CollapseContent>
    </Collapse>
  );
}
